module.exports = __webpack_public_path__ + "assets/663fcadaf84805edfde44ae746eaa295.mp3";